export const Pagination = "Pagination";
export const PaginationTotalCount = "Pagination__TotalCount";
